// Dependency-free cookie helpers (same API as the old app's CookieService)

export function get(key) {
  const escaped = key.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : undefined
}

export function set(key, value, options = {}) {
  const path = options.path || '/'
  let cookie = `${key}=${encodeURIComponent(value)}; path=${path}; SameSite=Lax`
  if (options.expires) {
    cookie += `; expires=${options.expires.toUTCString ? options.expires.toUTCString() : options.expires}`
  }
  // Secure requires HTTPS (localhost is treated as a secure context, so local dev still works)
  if (window.location.protocol === 'https:') {
    cookie += '; Secure'
  }
  document.cookie = cookie
}

export function remove(key) {
  document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`
}
